import { render } from "./Telephones.vue?vue&type=template&id=3afdd315"
import script from "./Telephones.vue?vue&type=script&lang=js"
export * from "./Telephones.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__